import { motion } from "framer-motion";
import { Link } from "react-router-dom";
import Overline from "./Overline";
import { reveal, revealStaggered, VIEW_60, VIEW_80 } from "./motion";

const PILLARS = [
  {
    id: "01",
    title: "Design and engineering are one conversation",
    content:
      "Concept, 3D, motion and code are produced by the same team under one creative direction. Nothing is handed off, diluted or templated between disciplines.",
  },
  {
    id: "02",
    title: "Performance is part of the art direction",
    content:
      "Frame budgets shape the lighting model, not the other way around. Reduced-motion fallbacks, mobile-aware scenes and disciplined asset loading are design decisions, not clean-up tasks.",
  },
  {
    id: "03",
    title: "Research runs continuously",
    content:
      "The experiments lab is always open — shader studies, generative type, spatial interfaces. Client work inherits what the research proves, and never the other way round.",
  },
];

export const AboutPerformance = () => (
  <section data-testid="about-performance" className="px-6 py-28 md:px-16 lg:px-24">
    <motion.div variants={reveal} initial="hidden" whileInView="show" viewport={VIEW_80}>
      <Overline>Approach</Overline>
      <h2 className="font-display max-w-3xl text-3xl font-bold leading-tight text-[#F4F6FB] md:text-5xl">
        How the studio actually operates.
      </h2>
    </motion.div>
    <div className="mt-16 border-t border-white/10">
      {PILLARS.map((p, i) => (
        <motion.div
          key={p.id}
          data-testid={`about-pillar-${p.id}`}
          variants={revealStaggered}
          initial="hidden"
          whileInView="show"
          viewport={VIEW_60}
          custom={i * 0.1}
          className="grid items-baseline gap-3 border-b border-white/10 py-10 transition-colors duration-500 hover:border-[#06B6D4]/40 md:grid-cols-[5rem_1fr_1.4fr] md:gap-10"
        >
          <span className="font-mono text-xs tracking-[0.3em] text-[#D4AF37]">{p.id}</span>
          <h3 className="font-display text-lg font-semibold text-[#F4F6FB] md:text-xl">{p.title}</h3>
          <p className="text-sm leading-relaxed text-[#F4F6FB]/55 md:text-base">{p.content}</p>
        </motion.div>
      ))}
    </div>
    <p className="mt-10 font-mono text-[11px] uppercase tracking-[0.25em] text-[#06B6D4]">
      <Link to="/experiments" data-testid="about-experiments-link" className="hover:text-[#F4F6FB]">
        See the experiments lab →
      </Link>
    </p>
  </section>
);

export default AboutPerformance;
